import React from 'react';
import './AnimatedBackground.css';

const AnimatedBackground = ({ variant = 'default' }) => {
  return (
    <div className={`animated-background ${variant}`}>
      <div className="gradient-orb orb-1"></div>
      <div className="gradient-orb orb-2"></div>
      <div className="gradient-orb orb-3"></div>
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
      </div>
    </div>
  );
};

export default AnimatedBackground;
